import { render } from "./gallery.vue?vue&type=template&id=3190fb39&scoped=true"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"

import "@/gallery/gallery/gallery.scss?vue&type=style&index=0&id=3190fb39&scoped=true&lang=scss&external"
import "./gallery.vue?vue&type=style&index=1&id=3190fb39&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3190fb39"]])

export default __exports__